import { render, staticRenderFns } from "./vedioMonitor.vue?vue&type=template&id=c2b941a2&scoped=true&"
import script from "./vedioMonitor.vue?vue&type=script&lang=js&"
export * from "./vedioMonitor.vue?vue&type=script&lang=js&"
import style0 from "./vedioMonitor.vue?vue&type=style&index=0&id=c2b941a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b941a2",
  null
  
)

export default component.exports